var React = require('react');

function ChevronuspInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M44 33.931L17.9614 5.35303e-06L2.13005e-06 3.78279e-06L24.5051 33.931L0 68L17.9614 68L44 33.931Z","fill":"#FFCD0A"}));
}

ChevronuspInline.defaultProps = {"width":"44","height":"74","viewBox":"0 0 44 74","fill":"none"};

module.exports = ChevronuspInline;

ChevronuspInline.default = ChevronuspInline;
